import React from "react"
import { MenuDefinition } from "../components/Menu"
import { BrowserRouter, Route, Routes, Navigate } from "react-router"
import MenuPage from "../components/MenuPage"
import AuthPage from "./Auth"
import Invite from "./Invite"
import RegPage from "./Registration"
import ForgotPage from "./Forgot"
import ResetPasswordPage from "./ResetPass"

type MenuMainProps = {
    pages: MenuDefinition[]
}

const PageRouter: React.FC<MenuMainProps> = ({ pages }) => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MenuPage pages={pages} defaultPage={pages[0].id} />} />
                <Route path="/sso" element={<AuthPage />} />
                <Route path="/reg" element={<RegPage />} />
                <Route path="/invite" element={<Invite />} />
                <Route path="/forgot" element={<ForgotPage />} />
                <Route path="/reset" element={<ResetPasswordPage />} />

                {pages.map((menu, i) => [
                    <Route
                        key={i + "menu"}
                        path={menu.path}
                        element={<MenuPage pages={pages} defaultPage={menu.id} />} />,
                    ...(menu.subs || []).map((sub, j) =>
                        <Route
                            key={i + "sub" + j}
                            path={sub.path}
                            element={<MenuPage pages={pages} defaultPage={sub.id} />} />)
                ]).flat()}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    )
}

export default PageRouter